import { render, staticRenderFns } from "./linkState.vue?vue&type=template&id=130f253e&"
import script from "./linkState.vue?vue&type=script&lang=js&"
export * from "./linkState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports